import { Box, Button, Divider, IconButton, Tooltip, Typography } from "@mui/material";
import { useStyles } from "../../styles";
import { useTranslation } from "react-i18next";
import { CustomPaper } from "../../../../../../../../../../components/CustomPaper";
import { ConfirmModal } from "../ConfirmModal";
import { useParams } from "react-router-dom";
import React, { useState } from "react";
import { SnackSimple } from "../../../../../../../../../../components";
import format from "date-fns/format";
import es from "date-fns/locale/es";
import EvidenceDetail from "../../../../../../../../../actionPlans/pages/form/components/evidenceDetail";
import { useEvidences } from "../../../../../../../../../../hooks/evidences/useEvidences";
import { icons } from "../../../../../../../../../../utils/icons";
import { Types } from "../../../../../../../../../../utils/enums/types";
import { ApproveRejectModal } from "../ApproveRejectModal";
import { reportFolioServices } from "../../../../../../../../../../utils/constants/callService";
import { VIEW_TYPES } from "../../../../types/ViewTypes";
import { Status } from "../../../../../../../../../../utils/enums";
import StarIcon from '@mui/icons-material/Star';
import { RatingModal } from "../ratingModal";
import { Questionnary } from "../Questionnary";
import { ActionDrawer } from "../../../../../../../../../../components/ActionDrawer";
import { useEvidenceDownload } from "../../../../../../../../../calendar/pages/detail/hooks";
import { Constants } from "../../../../../../../../../../utils/constants";
import { AnswerTypeHistory } from "../../../../enums/answerType";
import ExpandableText from "../ExpandibleText";

interface UserAssign {
  id: number;
  firstName: string;
  lastName: string;
}

interface Evidence {
  url: string;
  originalname: string;
  evidenceTypeId: number;
}

interface RequestCuoteInterface {
  items: Array<{
    instructionSubmitted: boolean;
    instruction: {
      id: number,
      reportFolioId: number,
      userId: number,
      evidencesInstruction: Evidence[] | undefined,
      instruction: string | null,
      userCreatorId: number,
      createTime: string | null,
      updateTime: string | null,
      deleteTime: string | null
    } | null;
    userReviewerQuote: any;
    statusIdQuote: Status;
    statusIdAnswer: Status;
    evidencesRejectionAnswer: Evidence[] | undefined;
    dateRequestManagement: any;
    statusId: Status;
    evidencesAnswer: Evidence[] | undefined;
    commentUpload: any;
    descriptionAnswer: any;
    idQuote: any;
    id: number;
    type: string;
    dateRequestCreateFolio: string;
    dateUploadQuote: string;
    dateUploadSolution: string;
    usersAssings: UserAssign[];
    userManageDepartment: number;
    newStep: string;
    typeHistory: string;
    requestSubmitted: boolean;
    evidencesQuote?: Evidence[];
    evidencesApprovalAnswer: Evidence[] | undefined;
    commentApprovalAnswer: string | null;
    reasonOfRejectionAnswer: string | null;
    userUploadAnswer: {
      id: number,
      firstName: string,
      lastName: string
    } | null;
    userReviewerAnswer: {
      id: number,
      firstName: string,
      lastName: string
    } | null;
  }>;
  reload: () => void;
  disabled: boolean;
  onAttend: any,
  left: any,
  list?: boolean,
  isMosaico?: boolean,
  position?: number,
  setCurrentDataSolution: any
}

export const ManageQuote = ({ items, reload, onAttend, left, disabled, list, isMosaico, position, setCurrentDataSolution }: RequestCuoteInterface) => {
  const styles = useStyles();
  const { t } = useTranslation();
  const { id: reportFolioId } = useParams<{ id: string }>();
  const rating = left?.rating
  const [isModalOpen, setModalOpen] = useState(false);
  const [isConfirmModalOpen, setConfirmModalOpen] = useState(false);
  const [actionType, setActionType] = useState<"approve" | "reject" | null>(null);
  const [comment, setComment] = useState("");
  const [isSubmitting, setSubmitting] = useState(false);
  const [confirmTitle, setConfirmTitle] = useState("");
  const [confirmDescription, setConfirmDescription] = useState("");
  const [approveSnack, setApproveSnack] = useState({
    open: false,
    message: ""
  });
  const [rejectSnack, setRejectSnack] = useState({
    open: false,
    message: ""
  });
  const [downloadSnack, setDownloadSnack] = useState({
    open: false,
    message: ""
  });

  const isManageSolution = items ? items?.[0]?.type === AnswerTypeHistory.MANAGE_SOLUTION : false;
  const firstRequestQuote = items?.filter((item) =>
    isManageSolution ? item.type === AnswerTypeHistory.MANAGE_SOLUTION : item.type === AnswerTypeHistory.MANAGE_QUOTE
  )[0];
  const isIntructionComment = !!items?.[0]?.instructionSubmitted

  const [modalOpen, setModalOpenRating] = useState(false);

  const isRejected = items ? items[0]?.statusId === Status.REJECTED || items[0]?.statusIdAnswer === Status.REJECTED || (items[0]?.type === AnswerTypeHistory.MANAGE_QUOTE && items[0]?.statusIdQuote === Status.REJECTED) : false
  const isApprove = items ? items[0]?.statusIdAnswer === Status.APPROVED : false
  const isQuoteApprove = items ? items[0]?.type === AnswerTypeHistory.MANAGE_QUOTE && items[0]?.statusIdQuote === Status.APPROVED : false


  const evidencesResponse =
    (firstRequestQuote?.evidencesQuote?.length ?? 0) > 0 ? firstRequestQuote?.evidencesQuote :
      (firstRequestQuote?.evidencesAnswer?.length ?? 0) > 0 ? firstRequestQuote?.evidencesAnswer : []

  const { evidences, existEvidences } = useEvidences({
    evidencesResponse: evidencesResponse,
    manualValue: false,
  });

  const { disable: isDownloading, downloadEvidences, } = useEvidenceDownload('evidencias', evidencesResponse);

  const provider = isManageSolution ? firstRequestQuote?.usersAssings?.[0]
    ? `${firstRequestQuote.usersAssings[0].firstName} ${firstRequestQuote.usersAssings[0].lastName}`
    : t("reportFolio.detail.general.noAssignedUser") : firstRequestQuote?.userReviewerQuote
    ? `${firstRequestQuote.userReviewerQuote.firstName} ${firstRequestQuote.userReviewerQuote.lastName}`
    : t("reportFolio.detail.general.noAssignedUser")



  const formattedDate = !isManageSolution ?
    firstRequestQuote?.dateUploadQuote
      ? format(new Date(firstRequestQuote.dateUploadQuote), Constants.dateFormatGeneral3, { locale: es })
      : t("reportFolio.detail.general.noDateAvailable")
    : firstRequestQuote?.dateUploadSolution ? format(new Date(firstRequestQuote.dateUploadSolution), Constants.dateFormatGeneral3, { locale: es })
      : t("reportFolio.detail.general.noDateAvailable")
    ;


  const formattedDateRejectOrApprove = firstRequestQuote?.dateRequestManagement
    ? format(new Date(firstRequestQuote.dateRequestManagement), Constants.dateFormatGeneral3, { locale: es })
    : t("reportFolio.detail.general.noDateAvailable");

  const commentUpload = firstRequestQuote?.commentUpload
  const commentSolution = firstRequestQuote?.descriptionAnswer
  const quoteId = firstRequestQuote?.idQuote

  const handleOpenModal = (type: "approve" | "reject") => {
    setActionType(type);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setComment("");
  };

  const handleConfirmSubmit = async () => {
    setSubmitting(true);
    try {
      let response;
      if (actionType === "approve") {
        response = await reportFolioServices.approveQuote(
          { commentApproval: comment, evidencesApproval: [] },
          quoteId
        );
        if (response?.code === "00") {
          setApproveSnack({
            open: true,
            message: t("reportFolio.detail.general.AprovedQuoteSucces")
          });
        }
      } else if (actionType === "reject") {
        response = await reportFolioServices.rejectQuote(
          { reasonOfRejection: comment, evidencesRejection: [] },
          quoteId
        );
        if (response?.code === "00") {
          setRejectSnack({
            open: true,
            message: t("reportFolio.detail.general.RejectQuoteSucces")
          });
        }
      }
    } catch (error) {
      console.error("Error:", error);
      if (actionType === "approve") {
        setApproveSnack({
          open: true,
          message: t("reportFolio.detail.general.oppsError")
        });
      } else {
        setRejectSnack({
          open: true,
          message: t("reportFolio.detail.general.oppsError")
        });
      }
    } finally {
      setSubmitting(false);
      setConfirmModalOpen(false);
      setActionType(null);
      window.location.reload();
    }
  };

  const handleSubmit = (actionType: "approve" | "reject", comment?: string) => {
    setConfirmTitle(
      actionType === "approve"
        ? t("reportFolio.detail.general.confirmTitle")
        : t("reportFolio.detail.general.confirmTitle")
    );
    setConfirmDescription(
      actionType === "approve"
        ? t("reportFolio.detail.general.confirmQuoteDescription")
        : t("reportFolio.detail.general.rejectQuoteDescription")
    );
    setConfirmModalOpen(true);
    setModalOpen(false);
  };

  const handleDownloadQuoteZip = async () => {
    setDownloadSnack({
      open: true,
      message: "Descargando evidencias..."
    });
    try {
      await downloadEvidences(isManageSolution ? firstRequestQuote?.evidencesAnswer : firstRequestQuote?.evidencesQuote, "evidences.zip");
    } catch (error) {
      console.error("Error downloading evidences:", error);
      setDownloadSnack({
        open: true,
        message: t("reportFolio.detail.general.oppsError")
      });
    } finally {
      setTimeout(() => {
        setDownloadSnack({
          open: false,
          message: ""
        });
      }, 3000);
    }
  };

  const seeOneDetail = () => {
    onAttend(VIEW_TYPES.DETAIL_ONE_SOLUTIOM)
    setCurrentDataSolution({
      evidencesAnswer: firstRequestQuote.evidencesAnswer,
      statusIdAnswer: firstRequestQuote.statusIdAnswer,
      evidencesRejectionAnswer: firstRequestQuote.evidencesRejectionAnswer,
      evidencesApprovalAnswer: firstRequestQuote.evidencesApprovalAnswer,
      descriptionAnswer: firstRequestQuote.descriptionAnswer,
      commentApprovalAnswer: firstRequestQuote.commentApprovalAnswer,
      reasonOfRejectionAnswer: firstRequestQuote.reasonOfRejectionAnswer,
      rating: left?.rating,
      dateUploadSolution: firstRequestQuote.dateUploadSolution,
      dateRequestManagement: firstRequestQuote.dateRequestManagement,
      userUploadAnswer: firstRequestQuote.userUploadAnswer,
      userReviewerAnswer: firstRequestQuote.userReviewerAnswer,
      isIntructionComment: isIntructionComment,
      position: position,
      isManagement: true
    })
  }

  const handleRatingConfirm = async (rating: number, comment?: string) => {
    const body = {
      rating,
      ...(comment && { ratingComment: comment })
    };

    try {
      const response = await reportFolioServices.ratingReportFolio({
        id: Number(reportFolioId),
        body
      });
      return response;
    } catch (error) {
      console.error('Error al enviar la calificación:', error);
      throw error;
    }
  };

  return (
    <>
      <CustomPaper sx={styles.userContainer} elevation={3}>
        <Box>
          {isManageSolution && !isRejected && !isApprove && !isQuoteApprove ? (
            <>
              <Typography sx={styles.title(2)}>
                {isIntructionComment ? t("reportFolio.detail.general.solutionCreator") : t("reportFolio.detail.general.solutionProvider")}
              </Typography>
              {position && <Typography sx={styles.position(2)}>{position}</Typography>}
            </>

          ) : !isManageSolution && isRejected ? (
            <Typography sx={styles.title(3)}>
              <Box display="flex" alignItems="center">
                {icons("cancel")}
                <span style={{ marginLeft: "8px" }}>
                  {t("reportFolio.detail.general.quotationTitleProviderSendCancel")}
                </span>
              </Box>
            </Typography>
          ) : !isManageSolution && !isRejected && !isQuoteApprove ? (
            <Typography sx={styles.title(2)}>
              {t("reportFolio.detail.general.quote")}
            </Typography>
          ) : isManageSolution && isRejected ? (<>
            <Typography sx={styles.title(3)}>
              <Box display="flex" alignItems="center">
                {icons("cancel")}
                <span style={{ marginLeft: "8px" }}>
                  {t("reportFolio.detail.general.solutionTitleProviderSendCancel")}
                </span>
              </Box>
            </Typography>
            {position && <Typography sx={styles.position(2)}>{position}</Typography>}
          </>) : isManageSolution && isApprove ? (<>
            <Box>
              <Box display="flex" alignItems="center">
                <Typography sx={styles.title(4)}>
                  {icons("check")}
                </Typography>
                <Typography style={{ marginLeft: '8px' }} sx={styles.title(4)}>
                  {t("reportFolio.detail.general.solutionTitleProviderSendApprove")}
                </Typography>
              </Box>
            </Box>
            {position && <Typography sx={styles.position(2)}>{position}</Typography>}
          </>) : isQuoteApprove ? (
            <>
              <Box display="flex" alignItems="center">
                <Typography sx={styles.title(4)}>
                  {icons("check")}
                </Typography>
                <Typography style={{ marginLeft: '8px' }} sx={styles.title(4)}>
                  {t("reportFolio.detail.general.quotationTitleProviderSendApprove")}
                </Typography>
              </Box>
            </>
          ) : <></>}
          {isMosaico
            ?
            <>
              <Typography variant="body2">
                {t("reportFolio.detail.general.sendSolutionAprovvedMosic", {
                  Date: formattedDate,
                })}
              </Typography>
              <Typography variant="body2">
                {isRejected
                  ? t("reportFolio.detail.general.rejectSolutionAprovvedMosic", { Rechazada: formattedDateRejectOrApprove })
                  : isApprove
                    ? t("reportFolio.detail.general.aproveSolutionAprovvedMosic", { Rechazada: formattedDateRejectOrApprove })
                    : null}
              </Typography>

            </>
            :
            <Typography variant="body2">
              {isRejected
                ? t("reportFolio.detail.general.providerAssignedAndDateAndReject", { Date: formattedDate, Rechazada: formattedDateRejectOrApprove })
                : isApprove || isQuoteApprove
                  ? t("reportFolio.detail.general.providerAssignedAndDateAndApprove", { Date: formattedDate, Rechazada: formattedDateRejectOrApprove })
                  : t("reportFolio.detail.general.providerAssignedAndDate", { Date: formattedDate })}
            </Typography>
          }

          {isManageSolution &&
            <Typography variant="body2">
              {t("reportFolio.detail.general.providerAssigned", { provider })}
            </Typography>
          }

          {commentUpload ? (
            <Typography
              sx={{
                '&.MuiTypography-root': {
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  whiteSpace: "normal",
                },
              }}
            >
              {commentUpload}
            </Typography>
          ) : <></>}

          {commentSolution && !isMosaico ? (
            <>
              {list ?
                <ExpandableText descriptionAnswer={commentSolution} />
                :
                <Typography sx={styles.description2}>
                  {commentSolution}
                </Typography>
              }

            </>
          )
            : <>
              {isManageSolution && !isRejected && !isApprove && <Button
                sx={styles.seeMore}
                onClick={() => { seeOneDetail() }}
              >
                {"Ver más"} {icons('view-less')}
              </Button>}
            </>
          }

          {isRejected ? (
            <Box display="flex" justifyContent="end" gap={2} mt={1}>
              <ActionDrawer
                title="EVIDENCIAS"
                body={<>
                  <Box sx={styles.mainContainer}>
                    <Box sx={styles.bodyContainer}>
                      <EvidenceDetail
                        existEvidences={existEvidences}
                        evidences={{
                          image: evidences?.images,
                          comment: evidences?.comments,
                          documents: evidences?.documents,
                          video: evidences?.video,
                          sign: evidences?.sign
                        }}
                      />
                    </Box>
                    <Box>
                      <Button variant='text_primary_small' onClick={downloadEvidences} disabled={isDownloading}>{t('schedule.buttons.downloadEvidence')}</Button>
                    </Box>
                  </Box>
                </>}
              >
                {
                  ({ openDrawer }) =>
                    <Tooltip title={t("ToolTips.seeEvidences")}>
                      <IconButton
                        onClick={() => { openDrawer() }}
                        sx={styles.clip}
                        disabled={!existEvidences}
                      >
                        {icons("clip")}
                      </IconButton>
                    </Tooltip>
                }
              </ActionDrawer>

              <Button variant="outlined" color="primary" onClick={() => { list ? seeOneDetail() : onAttend(VIEW_TYPES.DETAIL_QUOTE, firstRequestQuote?.id) }}>
                {isManageSolution ?
                  t("reportFolio.detail.general.seeSolutionDetail") :
                  t("reportFolio.detail.general.seeQuotationDetail")
                }
              </Button>
              {existEvidences ? (
                <Button variant="outlined" color="primary" onClick={handleDownloadQuoteZip}>
                  {isManageSolution ? t("reportFolio.detail.general.solutionDownload") : t("reportFolio.detail.general.dowloadQuote")}
                  < Box ml={1} mt={1}>{icons("download")}</Box>
                </Button>
              ) : <></>}

            </Box>
          ) : isApprove ? (
            <>
              <Box display="flex" gap={2} justifyContent="space-between" alignItems="flex-start">
                <Box display="flex" flexDirection="column" flex={1}>
                  {rating?.rating && (
                    <>
                      <Typography variant="body1" color="textSecondary">
                        {rating.ratingQuestion}
                      </Typography>

                      <Box display="flex">
                        {[1, 2, 3, 4, 5].map((star) => (
                          <Typography
                            key={star}
                            component="span"
                            sx={{
                              color: star <= rating.rating ? '#FFD700' : '#E0E0E0',
                              fontSize: '24px',
                            }}
                          >
                            <StarIcon />
                          </Typography>
                        ))}
                      </Box>

                      {rating.ratingComment && (
                        <Typography variant="body2" sx={{ '&.MuiTypography-root': { wordBreak: "break-word", overflowWrap: "break-word", whiteSpace: "normal", }, }}>{rating.ratingComment}</Typography>
                      )}
                    </>
                  )}
                </Box>

                <Box display="flex" gap={2} flexDirection="row">
                  {/* {rating?.showRating && !rating?.rating && (
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => setModalOpenRating(true)}
                    >
                      {t('reportFolio.detail.general.SatisfactionSurvey')}
                    </Button>
                  )} */}
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => { list ? seeOneDetail() : onAttend(VIEW_TYPES.DETAIL_QUOTE, firstRequestQuote?.id) }}
                  >
                    {t('reportFolio.detail.general.seeDetailSolution')}
                  </Button>
                </Box>
              </Box>
            </>
          ) : isQuoteApprove ? (
            <Box display="flex" justifyContent="end" gap={3} alignContent={"center"}>
              <ActionDrawer
                title="EVIDENCIAS"
                body={<>
                  <Box sx={styles.mainContainer}>
                    <Box sx={styles.bodyContainer}>
                      <EvidenceDetail
                        existEvidences={existEvidences}
                        evidences={{
                          image: evidences?.images,
                          comment: evidences?.comments,
                          documents: evidences?.documents,
                          video: evidences?.video,
                          sign: evidences?.sign
                        }}
                      />
                    </Box>
                    <Box>
                      <Button variant='text_primary_small' onClick={downloadEvidences} disabled={isDownloading}>{t('schedule.buttons.downloadEvidence')}</Button>
                    </Box>
                  </Box>
                </>}
              >
                {
                  ({ openDrawer }) =>
                    <Tooltip title={t("ToolTips.seeEvidences")}>
                      <IconButton
                        onClick={() => { openDrawer() }}
                        sx={styles.clip}
                        disabled={!existEvidences}
                      >
                        {icons("clip")}
                      </IconButton>
                    </Tooltip>
                }
              </ActionDrawer>
              <Button variant="outlined" color="primary" onClick={() => onAttend(VIEW_TYPES.DETAIL_QUOTE, firstRequestQuote?.id)}>
                {t("reportFolio.detail.general.seeDetailQuote")}
              </Button>
              <Button variant="outlined" color="primary" onClick={handleDownloadQuoteZip}>
                {t("reportFolio.detail.general.dowloadQuote")}
                <Box ml={1} mt={1}>{icons("download")}</Box>
              </Button>
            </Box>
          ) : (
            <Box display="flex" justifyContent="end" gap={2} mt={1}>
              <ActionDrawer
                title="EVIDENCIAS"
                body={<>
                  <Box sx={styles.mainContainer}>
                    <Box sx={styles.bodyContainer}>
                      <EvidenceDetail
                        existEvidences={existEvidences}
                        evidences={{
                          image: evidences?.images,
                          comment: evidences?.comments,
                          documents: evidences?.documents,
                          video: evidences?.video,
                          sign: evidences?.sign
                        }}
                      />
                    </Box>
                    <Box>
                      <Button variant='text_primary_small' onClick={downloadEvidences} disabled={isDownloading}>{t('schedule.buttons.downloadEvidence')}</Button>
                    </Box>
                  </Box>
                </>}
              >
                {
                  ({ openDrawer }) =>
                    <Tooltip title={t("ToolTips.seeEvidences")}>
                      <IconButton
                        onClick={() => { openDrawer() }}
                        sx={styles.clip}
                        disabled={!existEvidences}
                      >
                        {icons("clip")}
                      </IconButton>
                    </Tooltip>
                }
              </ActionDrawer>
              {existEvidences
                ?
                <Button variant="outlined" color="primary" onClick={handleDownloadQuoteZip}>
                  {isManageSolution ? t("reportFolio.detail.general.solutionDownload") : t("reportFolio.detail.general.dowloadQuote")}
                  < Box ml={1} mt={1}>{icons("download")}</Box>
                </Button>
                :
                <></>
              }
              {!list && <Button
                variant="contained"
                sx={{ backgroundColor: "#EC6666" }}
                onClick={() => {
                  if (isManageSolution) {
                    onAttend({
                      type: VIEW_TYPES.SOLUTION_FORM,
                      action: 'reject'
                    })
                  } else handleOpenModal("reject")
                }}
                disabled={isSubmitting || disabled}
              >
                {isManageSolution ? t("reportFolio.detail.general.rejectSolution") : t("reportFolio.detail.general.reject")}
              </Button>}
              {!list && <Button
                variant="contained"
                onClick={() => {
                  if (isManageSolution) {
                    onAttend({
                      type: VIEW_TYPES.SOLUTION_FORM,
                      action: 'approve'
                    })
                  } else {
                    handleOpenModal("approve")
                  }
                }}
                disabled={isSubmitting || disabled}
              >
                {isManageSolution ? t("reportFolio.detail.general.approveSolution") : t("reportFolio.detail.general.approve")}
              </Button>}
            </Box>
          )}
        </Box >

        {left?.type === "preventive" && isManageSolution && firstRequestQuote.assingQuestionnaire && (
          <>
            <Box sx={{ my: 2 }}>
              <Divider />
            </Box>
            <Box >
              <Questionnary data={left} historial={firstRequestQuote} />
            </Box>
          </>
        )}
      </CustomPaper >

      <ApproveRejectModal
        open={isModalOpen}
        onClose={handleCloseModal}
        onSubmit={handleSubmit}
        actionType={actionType}
        isSubmitting={isSubmitting}
        comment={comment}
        setComment={setComment}
      />

      <ConfirmModal
        open={isConfirmModalOpen}
        onClose={() => {
          setConfirmModalOpen(false);
        }}
        onConfirm={handleConfirmSubmit}
        title={confirmTitle}
        description={confirmDescription}
        reload={reload}
        simpleText
      />


      <SnackSimple
        open={approveSnack.open}
        close={() => setApproveSnack({ open: false, message: "" })}
        message={approveSnack.message}
        type={Types.SUCCESS}
      />


      <SnackSimple
        open={rejectSnack.open}
        close={() => setRejectSnack({ open: false, message: "" })}
        message={rejectSnack.message}
        type={Types.ERROR}
      />

      <SnackSimple
        open={downloadSnack.open}
        close={() => setDownloadSnack({ open: false, message: "" })}
        message={downloadSnack.message}
        type={Types.INFO}
      />

      <RatingModal
        open={modalOpen}
        onClose={() => setModalOpenRating(false)}
        onConfirm={handleRatingConfirm}
        reload={reload}
      />
    </>
  );
};
